import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "modalContent mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_TreeItem = _resolveComponent("TreeItem")!
  const _component_CommonButton = _resolveComponent("CommonButton")!

  return (_ctx.isBusy)
    ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "modalTitle" }, "Select Item", -1)),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            disabled: _ctx.TreeParameterNodes===null || _ctx.TreeParameterNodes.length===0  || null,
            placeholder: "Search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.SearchPattern) = $event))
          }, null, 8, _hoisted_3), [
            [_vModelText, _ctx.SearchPattern]
          ]),
          _createElementVNode("button", {
            class: "ml-3 btnViewerDefault",
            style: {"width":"90px","border-radius":"5px"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateControlLabel()))
          }, _toDisplayString(_ctx.TreeControlLabel), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_TransitionGroup, {
            name: "fso",
            tag: "span"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.RootNodes, (node, i) => {
                return _withDirectives((_openBlock(), _createBlock(_component_TreeItem, {
                  key: _ctx.key(i),
                  Definition: node,
                  Search: _ctx.SearchPattern
                }, null, 8, ["Definition", "Search"])), [
                  [_vShow, _ctx.showSearchNodes(node)]
                ])
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_CommonButton, {
          type: _ctx.ButtonType.Primary,
          text: _ctx.Localizer.Localize('Ok_PascalCase'),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.SetItem()))
        }, null, 8, ["type", "text"])
      ]))
}